import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
import PermissionTooltip from 'customer-data-objects-ui-components/permissions/PermissionTooltip';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'crm-... Remove this comment to see the full error message
import links from 'crm-legacy-links/links';
import PortalIdParser from 'PortalIdParser';
import { getReturnLink } from '../../utils/returnLinking';
import { trackIndexInteractionsEvent } from '../../tracking/indexPageTracking';
import { Text } from 'foundations-components/components/Text';
import { useIsUngatedForIARedesign } from '../../auth/hooks/useIsUngatedForIARedesign';
import { jsx as _jsx } from "react/jsx-runtime";
const EditPropertiesButton = ({
  typeDef,
  hasAllScopes
}) => {
  // we need to use this instead of IARedesignSwitch because the content needs to be the immediate child of the PermissionTooltip
  const isUngatedForIARedesign = useIsUngatedForIARedesign();
  const disabled = !hasAllScopes('crm-property-settings') && !hasAllScopes('manage-users-access');
  const hrefWithReturnLink = getReturnLink(links.propertySettingsRedesign(typeDef.objectTypeId), `/contacts/${PortalIdParser.get()}/objects/${typeDef.objectTypeId}/restore`);
  const onClickHandler = () => {
    trackIndexInteractionsEvent({
      action: 'clicked edit properties from action dropdown'
    });
  };
  const gatedContent = /*#__PURE__*/_jsx(Button, {
    "data-selenium-test": "edit-properties-link",
    disabled: disabled,
    href: hrefWithReturnLink,
    onClick: onClickHandler,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "topbarContents.editPropertiesSelector"
    })
  });
  const ungatedContent = /*#__PURE__*/_jsx(Button, {
    "data-selenium-test": "edit-properties-link",
    disabled: disabled,
    href: hrefWithReturnLink,
    onClick: onClickHandler,
    use: "transparent",
    children: /*#__PURE__*/_jsx(Text, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "topbarContents.editPropertiesSelector"
      })
    })
  });
  return /*#__PURE__*/_jsx(PermissionTooltip, {
    tooltipKey: "editPropertiesDisabled",
    disabled: !disabled,
    children: isUngatedForIARedesign ? ungatedContent : gatedContent
  });
};
export default EditPropertiesButton;